export const VIDEO_EXTENSIONS = ['.mp4', '.mov'];
export const MAX_VIDEO_SIZE = 25000000;

export const acceptVideoExtensionList = VIDEO_EXTENSIONS.join(',');
